/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockXeroPurchaseorderCtrl
 */
angular.module('mercury.modules.stock.xero')
.controller('StockXeroPurchaseorderCtrl', ["dialog", "$filter", "ngToast", "$q", "$resource", "$scope", "$state", "$stateParams", "$window", "StockItemSuperGroups", "StockSuppliers", "title", "userinfo", "Xero", function(dialog, $filter, ngToast, $q, $resource, $scope,
  $state, $stateParams, $window, StockItemSuperGroups, StockSuppliers, title, userinfo, Xero) {

  title.set('Export To Xero');

  //Get the exportData state params
  var exportData = JSON.parse($stateParams.exportData);
  $scope.reportParams = $stateParams.report;

  $scope.freightAccount = userinfo.companyPreferenceGet('xero.freightaccount');

  $scope.itemSuperGroups = StockItemSuperGroups.getAll();

  var allSuppliers = StockSuppliers.getAll();
  allSuppliers.$promise.then(function() {
    $scope.suppliers = $filter('filter')(allSuppliers, function(supplier) {
      return exportData.suppliers.indexOf(supplier.id) !== -1;
    });
  });

  var fetchXeroData = function() {
    $scope.loading = Xero.getSupportData();
    $scope.loading.then(function(results) {
      $scope.xeroAccounts = results.accounts;
      $scope.xeroContacts = results.contacts;

      $scope.xeroContacts.unshift({id: '00000000-0000-0000-0000-000000000000', name: 'Create new supplier in Xero.'});
    });
  };

  /**
   * Check for an active Xero Session
   */
  $scope.connectionStatus = Xero.getConnectionStatus();

  $scope.loading = $q.all([allSuppliers.$promise, $scope.connectionStatus.$promise, $scope.itemSuperGroups.$promise]);
  $scope.loading.then(function() {
    if ($scope.connectionStatus.hasAuth) {
      fetchXeroData();
    }
  });

  $scope.connect = function() {
    // store our current state so we know what we were doing when Xero redirects us back
    $window.localStorage.setItem('@@loaded/connections/resume', window.location.href.split('#').pop() || '');

    // navigate to auth url to begin auth flow
    window.location = $scope.connectionStatus.authUrl;
  };

  $scope.disconnect = function() {
    Xero.disconnect()
    .then(function() {
      $scope.connectionStatus = Xero.getConnectionStatus();
    });
  };

  $scope.setSuperGroupAccount = function(superGroup) {
    if ($scope.xeroMappingForm['account' + superGroup.id].$valid) {
      StockItemSuperGroups.updateXeroAccount(superGroup.id, superGroup.xeroAccountCode);
    }
  };

  $scope.setFreightAccount = function() {
    if ($scope.xeroMappingForm.accountfreight.$valid) {
      Xero.setFreightAccountDefault($scope.freightAccount);
    }
  };

  $scope.setDefaultSupplier = function(supplier) {
    if ($scope.xeroMappingForm['contact' + supplier.id].$valid) {
      StockSuppliers.patch(supplier.id, 'thirdPartyContactId', supplier.thirdPartyContactId);
    }
  };

  /**
  * Complete the current export
  */
  $scope.exportComplete = function() {
    $scope.xeroMappingForm.$setSubmitted();
    if ($scope.xeroMappingForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the missing mapping with Xero');
      return;
    }

    if (exportData.type == 'statements') {
      $scope.exportPromise = Xero.exportStatements(exportData.combine, exportData.ids);
    } else {
      $scope.exportPromise = Xero.exportPurchaseOrders(exportData.combine, exportData.ids);
    }

    $scope.exportPromise.then(function(results) {
      var exportResults = {invoices: [], creditNotes: []};
      angular.forEach(results, function(result) {
        if (result.total < 0) {
          exportResults.creditNotes.push(result);
        } else {
          exportResults.invoices.push(result);
        }
      });
      $scope.exportResults = exportResults;
    });
  };
}]);
